import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getDepositorWireDetailsPath = (id: string = ':id') => urlHelper(`/depositor/wire/${id}/details`);
